// @flow
import { type Validation } from './types';

export function hasSubmitError(validation: Validation): boolean {
  return !!validation.submitError;
}
